import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "convex/react";
import { api } from "@convex/_generated/api";
import type { Id } from "@convex/_generated/dataModel";
import { useLeague } from "@/features/leagues/hooks/useLeague";
import { RecentContributionsTable } from "@/features/leagues/standings/components/RecentContributionsTable";
import { PageContainer } from "@/shared/layout/PageContainer";
import { PageHeader } from "@/shared/layout/PageHeader";
import { Skeleton } from "@/shared/ui/Skeleton";
import { useT } from "@/shared/i18n/LocaleContext";

export const Route = createFileRoute(
  "/_authenticated/leagues/$leagueId/players/contributions",
)({
  component: LeagueContributionsPage,
});

function LeagueContributionsPage() {
  const { leagueId } = Route.useParams();
  const t = useT();
  const data = useLeague(leagueId as Id<"leagues">);
  const rows = useQuery(api.standings.listLeagueContributions, {
    leagueId: leagueId as Id<"leagues">,
    limit: 200,
  });

  if (data === undefined || rows === undefined) {
    return (
      <PageContainer>
        <Skeleton className="h-12 w-2/3 mb-8" />
        <Skeleton className="h-96 w-full" />
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <PageHeader
        eyebrow={data.league.name}
        title={t("league.dashboard.contributions.pageTitle")}
      />
      <RecentContributionsTable leagueId={leagueId as Id<"leagues">} rows={rows} />
    </PageContainer>
  );
}
